<template lang="html">
  <v-flex>

    <div
      id="address"
      class="anchor"
    ></div>

        <div class="d-flex">
        <div v-if="checkedStakes" class="d-flex flex-column justify-center">



        <v-card
          class="mr-5 py-5 px-0 pt-10 pb-0 mb-0 text-center rounded-xl"
          min-width="250"
          height="240"
          elevation="10"
          :color="wiseclassColor"
        >

          <div class="display-4 shadow">
            {{ wiseclassIcon }}
          </div>
          <v-card-title class="justify-center">
            {{ wiseclassName }}
          </v-card-title>

          <v-card-subtitle class="text-center font-weight-bold shadow white--text">
            {{ wiseclassShares | toInt(0, "WCP") }}
          </v-card-subtitle>
        </v-card>
        <div class="text-center">
          <a class="helplink text-caption" @click="showWiseClassesHelp = true;">About Wise Classes</a>
        </div>

        <v-dialog
          v-model="showWiseClassesHelp"
          width="400"
        >
          <v-card elevation="4">
            <v-card-title class="headline">
              Info about Wise Classes
            </v-card-title>
            <v-card-text>
              <p>
                WISE Classes are a <span class="font-weight-bold" style="color: #29ABB5">rating system to show how valuable an account is for the longterm success of WISE</span>. "Wise Class Points" (in short: WCP) are calculated for the given account based on its stakes and liquid WISE. The more WCP an account gets, the more valuable an account is for the WISE ecosystem.
              </p>
              <p class="mb-0">
                Stakes and WISE are rated and compared like this:
              </p>
              <ul class="mb-4">
                <li>Stakes are better than liquid WISE</li>
                <li>Long stakes are better than short stakes</li>
                <li>Big stakes are better than small stakes</li>
                <li>A stake at the beginning of its lifetime is better than a stake maturing soon</li>
              </ul>
              <p>
                This means: if you want to get a high WCP scoring, you should <span class="font-weight-bold" style="color: #29ABB5">stake as much and as long as you can.</span> Based on the calculated amount of WCP, the account is awarded with one of the following "WISE Class":
              </p>
              <v-row v-for="wiseclass in wiseclassesExtended" :key="wiseclass.name" class="align-center">
                <!-- <v-col v-if="wiseclass.name === 'ME'" color="red" cols="2" class="text-center py-0">
                  <span class="display-1 shadowsmall" :style="{ 'background-color': wiseclass.color, 'border-radius': '5px' }">{{ wiseclass.icon }}</span>
                </v-col> -->
                <v-col cols="2" class="text-center py-0">
                  <span class="display-1 shadowsmall" :style="{ 'background-color': wiseclass.color, 'border-radius': '5px' }">{{ wiseclass.icon }}</span>
                </v-col>
                <v-col v-if="wiseclass.name === 'ME'" cols="5" class="text-left font-weight-bold tealtext">
                  {{ wiseclass.name }}
                </v-col>
                <v-col v-else cols="5" class="text-left font-weight-bold">
                  {{ wiseclass.name }}
                </v-col>
                <v-col cols="5" class="text-right">
                  {{ wiseclass.limit | toInt(0, "WCP")}}
                </v-col>
              </v-row>
              <p class="mt-5 caption">
                The rating system might change and adapt in the future. Please let me know if you think the given rating is inadequate or if you think you have an idea how to improve it. Thanks!
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#29ABB5"
                text
                @click="showWiseClassesHelp = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        </div>

      <!-- <v-flex class="d-flex flex-column justify-center pt-10 mb-10"> -->
        <v-card
          elevation="4"
          class="mb-3"
        >
          <v-card-title class="headline">
            Account Visualizer
          </v-card-title>
          <v-card-text class="pb-0">
            <ul class="mb-3">
              <li>
                Enter your Account to get a visual representation of your stakes and information about your stakes, your shares and your pending interest and your CM referrer rewards. More to come soon. Bookmark your direct link
              </li>
              <li>
                Because of privacy concerns, income, interest rates and CM stats are only visible for your own accounts, connected with MetaMask
              </li>
            </ul>

            <v-row class="pa-0 ma-0 align-baseline">
              <v-col class="pb-0">
                <v-text-field
                  label="Account"
                  placeholder="Account Address"
                  v-model="stakeAddress"
                  append-icon="mdi-magnify"
                  outlined
                  color="#29ABB5"
                  :rules="accountRules"
                  @input="getStakes"
                  @click:append="getStakes"
                  @click:clear="clearAccount"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="4" class="text-right">
                <v-btn
                  v-if="isMetaMaskConnected"
                  color="#f4772e"
                  class="text-none"
                  @click="setMetamaskAccount"
                >
                  <span class="mr-2">Show Account {{shortenedAccount}}</span>
                </v-btn>

                <v-btn
                  v-else
                  color="#f4772e"
                  @click="connectMetamask"
                >
                  <span class="mr-2">Connect Metamask</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

        </v-card>
        </div>


      <div
        v-if="graphLoading"
        class="text-center"
      >
        <v-progress-circular
          indeterminate
          size="60"
          width="10"
          color="#29ABB5"
          class="my-5"
        ></v-progress-circular>
        <p>
          Loading Data...
        </p>
      </div>

        <div v-if="checkedStakes">

          <div>
            <v-flex class="d-flex flex-wrap justify-center">
            <!-- <v-card
              class="mr-5 py-5 px-0 pb-0 mb-10 text-center rounded-lg"
              width="250"
              height="200"
              elevation="4"
              rounded
              :color="wiseclassColor"
            >

              <div class="display-4 shadow">
                {{ wiseclassIcon }}
              </div>
              <v-card-title class="justify-center">
                {{ wiseclassName }}
              </v-card-title>

              <v-card-subtitle class="text-center font-weight-bold shadow white--text">
                {{ wiseclassShares | toInt(0, "WCP") }}
              </v-card-subtitle>
              <v-card-text class="text-center">
                <a class="helplink text-caption" @click="showWiseClassesHelp = true;">About Wise Classes</a>
              </v-card-text>
            </v-card> -->


            <div class="break"></div>

            <v-card
              class="ma-2 px-2"
              elevation="4"
              width="350">
              <v-card-title class="pa-2 mb-1 pb-1">
                Balances
              </v-card-title>
              <v-divider class="mx-2"></v-divider>
              <v-card-text class="pa-2 mt-0 pt-0">
                <v-row class="align-center mt-0 mb-0">
                  <v-col cols="6">
                    Total WISE:
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-sheet
                    elevation="2"
                    class="d-inline-flex flex-column mb-1 pt-1 px-1 font-weight-bold body-1 text-right"
                    rounded
                    color="#29abb5"
                    >
                    {{ balance + totalStaked | toInt(0, "WISE") }}<br />
                    <span class="text-caption">{{ balanceUSD + totalStakedUSD | toCurrency(2, "USD") }}</span>
                  </v-sheet>
                </v-col>
              </v-row>
              <v-divider></v-divider>
                <v-row class="align-center mt-0 mb-2 ml-5">
                  <v-col cols="6">
                    Liquid WISE:
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ balance | toInt(0, "WISE") }}<br />
                    <span class="mt-0 pt-0 text-caption">{{ balanceUSD | toCurrency(2, "USD") }}</span>
                  </v-col>
                </v-row>
                <v-row class="align-center mb-4 ml-5">
                  <v-col cols="6" class="my-0 py-0 ">
                    Staked WISE:
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ totalStaked | toInt(0, "WISE") }}<br />
                    <span class="text-caption">{{ totalStakedUSD | toCurrency(2, "USD") }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>

            <v-card
              class="ma-2 px-2"
              elevation="4"
              width="350">
              <v-card-title class="pa-2 mb-1 pb-1">
                Stakes
              </v-card-title>
              <v-divider class="mx-2"></v-divider>
              <v-card-text class="pa-2 mt-0 pt-0">
                <v-row class="align-center mt-0">
                  <v-col cols="6">
                    Number of Stakes:
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ existingStakes.length }}
                  </v-col>
                </v-row>
                <v-row class="align-center mt-2">
                  <v-col cols="6" class="my-0 py-0 ">
                    Weighted Avg. Length
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ avgLength | toInt(1, "days")}}
                  </v-col>
                </v-row>
                <v-row class="align-center mt-5 mb-2">
                  <v-col cols="6" class="my-0 py-0 ">
                    My Active Shares:
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ totalShares | toInt(0, "SH")}}
                  </v-col>
                </v-row>
                <v-row class="align-center mt-5 mb-2">
                  <v-col cols="6" class="my-0 py-0 ">
                    Global total Shares:
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ this.$store.state.totalShares | toInt(0, "SH") }}
                  </v-col>
                </v-row>
                <v-row class="align-center mt-5 mb-2">
                  <v-col cols="6" class="my-0 py-0 ">
                    Shares Percentage:
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ mySharesPercentage.toFixed(6) }}%
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              class="ma-2 px-2"
              elevation="4"
              width="350">
              <v-card-title class="pa-2 mb-1 pb-1">
                Interest Income
              </v-card-title>
              <v-divider class="mx-2"></v-divider>
              <v-card-text v-if="showIncomeStats" class="pa-2 mt-2 pt-0">
                <v-row class="align-center mt-0">
                  <v-col cols="6" class="my-0 py-0">
                    Earned Interest:
                  </v-col>
                  <v-col cols="6" class="text-right my-0 py-0">
                    <v-sheet
                      elevation="2"
                      class="d-inline-flex flex-column mb-1 pt-1 px-1 font-weight-bold body-1 text-right"
                      rounded
                      color="#29abb5"
                    >
                      +{{ pendingInterest | toInt(2, "WISE")}}<br />
                      <span class="text-caption">{{ pendingInterestUSD | toCurrency(2, "USD")}}</span>
                    </v-sheet>
                  </v-col>
                </v-row>
                <v-row class="align-center my-2 py-2">
                  <v-col cols="6" class="my-0 py-0">
                    APY
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ totalAPY.toFixed(2) }}%
                  </v-col>
                </v-row>
                <v-row class="align-center mb-2">
                  <v-col cols="6" class="my-0 py-0 ">
                    Daily Income
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ this.totalRewardsPerDay | toInt(2, "WISE") }}<br />
                    <span class="mt-0 pt-0 text-caption">{{ this.totalRewardsPerDay * this.currentWisePrice | toCurrency(2, "USD") }}</span>
                  </v-col>
                </v-row>
                <v-row class="align-center mb-2">
                  <v-col cols="6" class="my-0 py-0 ">
                    Monthly Income
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ this.totalRewardsPerDay * 365 / 12 | toInt(2, "WISE") }}<br />
                    <span class="mt-0 pt-0 text-caption">{{ this.totalRewardsPerDay * 365 / 12 * this.currentWisePrice | toCurrency(2, "USD") }}</span>
                  </v-col>
                </v-row>
                <v-row class="align-center mb-2">
                  <v-col cols="6" class="my-0 py-0 ">
                    Yearly Income
                  </v-col>
                  <v-col cols="6" class="my-0 py-0 body-1 text-right">
                    {{ this.totalRewardsPerDay * 365 | toInt(2, "WISE") }}<br />
                    <span class="mt-0 pt-0 text-caption">{{ this.totalRewardsPerDay * 365 * this.currentWisePrice | toCurrency(2, "USD") }}</span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else class="pa-2 mt-5 pt-0">
                <v-row class="text-center">
                  <v-col cols="12" class="my-0 py-0">
                    Visible only for accounts connected with Metamask<br />(because of privacy issues)
                  </v-col>
                </v-row>
                <v-row class="text-center mt-5">
                  <v-col cols="12" class="my-0 py-0">
                    <v-btn
                      v-if="!isMetaMaskConnected"
                      color="#f4772e"
                      @click="connectMetamask"
                    >
                      <span class="mr-2">Connect Metamask</span>
                    </v-btn>
                    <v-btn
                      v-if="isMetaMaskConnected"
                      color="#f4772e"
                      class="text-none"
                      @click="setMetamaskAccount"
                    >
                      <span class="mr-2">Show Account {{shortenedAccount}}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-card
              class="ma-2 px-2"
              elevation="4"
              width="700">
              <v-card-title class="pa-2 mb-1 pb-1">
                CM Referrer Income
              </v-card-title>
              <v-divider class="mx-2"></v-divider>
              <v-overlay
              :value="cmIncomeLoading"
              absolute="absolute"
              opacity="1"
              >
              <div class="text-center">
                <v-progress-circular
                indeterminate
                size="60"
                width="10"
                color="#29abb5"
                class="my-5"
                ></v-progress-circular>
                <p>
                  Loading CM Data...
                </p>
              </div>
            </v-overlay>

              <v-card-text v-if="showCMIncome && accountIsCMReferrer" class="pa-2 mt-2 pt-0">

                <v-row class="mt-0">
                  <v-col cols="6">
                    <v-row class="align-center mt-0">
                      <v-col cols="6" class="my-0 py-0">
                        Earned Interest:
                      </v-col>
                      <v-col cols="6" class="text-right my-0 py-0">
                        <v-sheet
                          elevation="2"
                          class="d-inline-flex flex-column mb-1 pt-1 px-1 font-weight-bold body-1 text-right"
                          rounded
                          color="#29abb5"
                        >
                          +{{ pendingCMIncome | toInt(2, "WISE")}}<br />
                          <span class="text-caption">{{ pendingCMIncome * this.currentWisePrice | toCurrency(2, "USD")}}</span>
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <v-row class="align-center mt-3">
                      <v-col cols="6" class="my-0 py-0">
                        Total CM Shares:
                      </v-col>
                      <v-col cols="6" class="text-right my-0 py-0">
                        {{ this.$store.state.referralShares | toInt(0, "rSHRS") }}
                      </v-col>
                    </v-row>
                    <v-row class="align-center mt-4">
                      <v-col cols="6" class="my-0 py-0">
                        My CM Shares:
                      </v-col>
                      <v-col cols="6" class="text-right my-0 py-0">
                        {{ myCMShares | toInt(0, "rSHRS") }}
                      </v-col>
                    </v-row>
                    <v-row class="align-center mt-4">
                      <v-col cols="8" class="my-0 py-0">
                        My CM Shares Percentage:
                      </v-col>
                      <v-col cols="4" class="text-right my-0 py-0">
                        {{ myCMSharesPercentage.toFixed(6) }}%
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="8" class="my-0 py-0">
                        Referred Stakes:
                      </v-col>
                      <v-col cols="4" class="text-right my-0 py-0">
                        {{ numberReferredStakes }}
                      </v-col>
                    </v-row>
                    <v-row class="align-center">
                      <v-col cols="6" class="my-0 py-0">
                        Referred Total USD:
                      </v-col>
                      <v-col cols="6" class="text-right my-0 py-0">
                        {{ totalReferredUsd | toCurrency(2, "USD")}}
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="6">
                    <v-row class="align-center mb-2 mt-2 pt-7">
                      <v-col cols="6" class="my-0 py-0 ">
                        Daily CM Income
                      </v-col>
                      <v-col cols="6" class="my-0 py-0 body-1 text-right">
                        {{ this.cmIncomePerDay | toInt(2, "WISE") }}<br />
                        <span class="mt-0 pt-0 text-caption">{{ this.cmIncomePerDay * this.currentWisePrice | toCurrency(2, "USD") }}</span>
                      </v-col>
                    </v-row>
                    <v-row class="align-center mb-2">
                      <v-col cols="6" class="my-0 py-0 ">
                        Monthly CM Income
                      </v-col>
                      <v-col cols="6" class="my-0 py-0 body-1 text-right">
                        {{ this.cmIncomePerDay * 365 / 12 | toInt(2, "WISE") }}<br />
                        <span class="mt-0 pt-0 text-caption">{{ this.cmIncomePerDay * 365 / 12 * this.currentWisePrice | toCurrency(2, "USD") }}</span>
                      </v-col>
                    </v-row>
                    <v-row class="align-center mb-2">
                      <v-col cols="6" class="my-0 py-0 ">
                        Yearly CM Income
                      </v-col>
                      <v-col cols="6" class="my-0 py-0 body-1 text-right">
                        {{ this.cmIncomePerDay * 365 | toInt(2, "WISE") }}<br />
                        <span class="mt-0 pt-0 text-caption">{{ this.cmIncomePerDay * 365 * this.currentWisePrice | toCurrency(2, "USD") }}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else-if="showCMIncome && !accountIsCMReferrer" class="pa-2 mt-5 pt-0">
                <v-row class="text-center">
                  <v-col cols="12" class="my-0 py-0 mb-3">
                    No CM Status reached yet. Keep going!
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else class="pa-2 mt-5 mb-5 pt-0">
                <v-row class="text-center my-2">
                  <v-col cols="12" class="my-0 py-0">
                    Visible only for accounts connected with Metamask<br />(because of privacy issues)
                  </v-col>
                </v-row>
                <v-row class="text-center mt-5">
                  <v-col cols="12" class="my-0 py-0">
                    <v-btn
                      v-if="!isMetaMaskConnected"
                      color="#f4772e"
                      @click="connectMetamask"
                    >
                      <span class="mr-2">Connect Metamask</span>
                    </v-btn>
                    <v-btn
                      v-if="isMetaMaskConnected"
                      color="#f4772e"
                      class="text-none"
                      @click="setMetamaskAccount"
                    >
                      <span class="mr-2">Show Account {{shortenedAccount}}</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
          <div class="text-center mt-5">
            <v-btn
            :href="directLink"
            target="_blank"
            color="secondary"
            class="mx-3"
            >Direct Link to this view</v-btn>
          </div>
          <div class="text-center">
            (can be bookmarked)
          </div>

          <v-flex class="d-flex flex-wrap justify-center my-10">
            <v-btn
              color="#29abb5"
              class="my-3 mx-2"
              :href="referralLinkStaking"
              target="_blank"
              @click="captureReferralLink('referrallink_home', referralLink); return false;"
              x-large
            >
              More Stakes - More Interest!
            </v-btn>
          </v-flex>



            <!-- <h2>{{ existingStakes.length }} Existing Stakes</h2> -->
            <!-- stakes() -->
            <!-- <v-simple-table
              v
              dense
              fixed-header
              class="mx-0">
                <thead>
                  <tr>
                    <th>Stake Id</th>
                    <th class="text-right">stakesShares</th>
                    <th class="text-right">stakedAmount</th>
                    <th class="text-right">rewardAmount</th>
                    <th class="text-right">startDay</th>
                    <th class="text-right">lockDays</th>
                    <th class="text-right">finalDay</th>
                    <th class="text-right">closeDay</th>
                    <th class="text-right">scrapeDay</th>
                    <th class="text-right">daiEquivalent</th>
                    <th class="text-right">referrerShares</th>
                    <th class="text-right">referrer</th>
                    <th class="text-right">isActive</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="existingStake in existingStakes" :key="existingStake.index" class="ml-5 pr-0">
                    <td>{{ existingStake.stakeId.slice(0, 6) }}....{{ existingStake.stakeId.slice(existingStake.stakeId.length - 4) }}</td>
                    <td class="text-right">{{ (existingStake.stakesShares / 10 ** 18).toFixed(2) }}</td>
                    <td class="text-right">{{ (existingStake.stakedAmount / 10 ** 18).toFixed(2) }}</td>
                    <td class="text-right">{{ (existingStake.rewardAmount / 10 ** 18).toFixed(2) }}</td>
                    <td class="text-right">{{ existingStake.startDay }}</td>
                    <td class="text-right">{{ existingStake.lockDays }}</td>
                    <td class="text-right">{{ existingStake.finalDay }}</td>
                    <td class="text-right">{{ existingStake.closeDay }}</td>
                    <td class="text-right">{{ existingStake.scrapeDay }}</td>
                    <td class="text-right">{{ existingStake.daiEquivalent }}</td>
                    <td class="text-right">{{ existingStake.referrerShares }}</td>
                    <td class="text-right">{{ existingStake.referrer }}</td>
                    <td class="text-right">{{ existingStake.isActive }}</td>
                  </tr>
                </tbody>
            </v-simple-table> -->

            <!-- checkStakeByID() -->
            <div style="position: relative">


            <v-overlay
            :value="graphLoading"
            absolute="absolute"
            opacity="1"
            >
            <div class="text-center">
              <v-progress-circular
              indeterminate
              size="60"
              width="10"
              color="#29abb5"
              class="my-5"
              ></v-progress-circular>
              <p>
                Loading CM Data...
              </p>
            </div>
          </v-overlay>
        </div>

        <ChartCard :title="existingStakes.length + ' Existing Stakes'" >

            <highcharts
              :options="chartOptionsStakes"
              v-show="showGraph"
              v-if="existingStakes.length > 0"
            ></highcharts>

          </ChartCard>
            <!-- Axis Scale:
            <v-btn
              small
              @click="setAxisLogScale(true)"
            >
              logarithmic
            </v-btn>
            <v-btn
              small
              @click="setAxisLogScale(false)"
            >
              linear
            </v-btn> -->

            <v-card class="mt-4" elevation="4">
              <v-card-text>


            <v-simple-table
              v-if="existingStakes.length > 0"
              fixed-header
              dense
              class="mx-0 mt-5">
                <thead>
                  <tr>
                    <th>Stake Index</th>
                    <th>Stake Id</th>
                    <th class="text-right">startDay</th>
                    <th class="text-right">lockDays</th>
                    <th class="text-right">finalDay</th>
                    <th class="text-right">closeDay</th>
                    <th class="text-right">scrapeDay</th>
                    <th class="text-right">stakedAmount</th>
                    <th class="text-right">stakesShares</th>
                    <th class="text-right">rewardAmount</th>
                    <th class="text-right">penaltyAmount</th>
                    <th class="text-right">isActive</th>
                    <th class="text-right">isMature</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="existingStake in existingStakes" :key="existingStake.index" class="ml-5 pr-0">
                    <td>{{ existingStake.index }}</td>
                    <td>{{ existingStake.stakeId.slice(0, 6) }}....{{ existingStake.stakeId.slice(existingStake.stakeId.length - 4) }}</td>
                    <td class="text-right">{{ existingStake.startDay }}</td>
                    <td class="text-right">{{ existingStake.lockDays }}</td>
                    <td class="text-right">{{ existingStake.finalDay }}</td>
                    <td class="text-right">{{ existingStake.closeDay }}</td>
                    <td class="text-right">{{ existingStake.scrapeDay }}</td>
                    <td class="text-right">{{ (existingStake.stakedAmount / 10 ** 18).toFixed(2) }}</td>
                    <td class="text-right">{{ (existingStake.stakesShares / 10 ** 18).toFixed(2) }}</td>
                    <td class="text-right">{{ (existingStake.rewardAmount / 10 ** 18).toFixed(6) }}</td>
                    <td class="text-right">{{ (existingStake.penaltyAmount / 10 ** 18).toFixed(2) }}</td>
                    <td class="text-right">{{ existingStake.isActive }}</td>
                    <td class="text-right">
                      <v-chip
                      label
                      small
                        :color="existingStake.isMature ? 'green' : 'orange'"
                      >
                        {{ existingStake.isMature }}
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
            </v-simple-table>

          </v-card-text>
        </v-card>

          </div>
        </div>

      <!-- </v-flex> -->

    </v-flex>
</template>

<script>
import {
    Chart
  } from "highcharts-vue";
  import Highcharts from "highcharts";
  import dark from "highcharts/themes/dark-unica";
  import datagrouping from "highcharts/modules/datagrouping";
  import stockInit from 'highcharts/modules/stock'
  import boost from "highcharts/modules/boost";
  stockInit(Highcharts);
  boost(Highcharts);
  dark(Highcharts);
  datagrouping(Highcharts);
  Highcharts.setOptions({
    lang: {
      numericSymbols: ['k', 'M', 'B', 'T', 'P', 'E']
    }
  });

  Highcharts.setOptions({
    colors: ['#3c44b1', '#33b1f6', '#29abb5', '#ffdc00']
  });

  import {
    getStakes,
    getBalance,
    isValidAccount,
    isValidAccountAsync
  } from "../utils/dataPoller";

  import {
    connectWeb3,
  } from '../utils/getWeb3';

  import {
    mapState
  } from 'vuex';

  var VueScrollTo = require('vue-scrollto');

  import config from "@/utils/config.json";

  import ChartCard from "@/components/widgets/ChartCard.vue"

  // import {
  //   getInfuraWeb3,
  //   getInfuraWiseContract,
  // } from "../utils/contract_mainnet_staking";


  // import Vue from 'vue';

  export default {
    name: "StakeVisualizer",
    data() {
      return {
        wiseContract: null,
        web3: null,
        stakeAddress: "",
        existingStakes: [],
        checkedStakes: false,
        balance: 0,
        balanceUSD: 0,
        totalStaked: 0,
        totalStakedUSD: 0,
        avgLength: 0,
        totalShares: 0,
        pendingInterest: 0,
        pendingInterestUSD: 0,
        wiseclassShares: 0,
        wiseclassName: "",
        wiseclassIcon: "",
        wiseclassLimit: 0,
        wiseclassColor: "rgb(41,171,181)",
        showWiseClassesHelp: false,
        wiseclasses: [],
        // showCMIncome: false,
        chart: null,
        godMode: false, //TOD
        pendingCMIncome: 0,
        totalCMShares: 0,
        accountIsCMReferrer: false,
        myCMShares: 0,
        myCMSharesPercentage: 0,
        mySharesPercentage: 0,
        numberReferredStakes: 0,
        totalReferredUsd: 0,
        cmIncomePerDay: 0,
        cmIncomeLoading: false,
        rules: {
          address: this.wrongAddress || "Wrong Address."
        },
        accountRules: [
          v => (!v || isValidAccountAsync(v)) || 'Invalid Account'
        ],
        showGraph: true,
        graphLoading: false,
        directLink: "",
      }
    },
    components: {
      highcharts: Chart,
      ChartCard
    },
    created() {

    },
    mounted() {
      this.wiseclasses = config.wiseclasses;
      this.$nextTick(() => {
        if (this.$route.params.address) {
          this.stakeAddress = this.$route.params.address;
          this.getStakes();
          // this.updateDirectLink();
        }
        if (this.$route.name === "address") {
          this.scrollMeTo("address");
        }
      });
    },
    watch: {
      metamaskAccountChange() {
        this.reloadStakes();
      },
      metamasknetworkIdChange() {
        this.reloadStakes();
      },
      metamaskConnectedChange() {
        this.reloadStakes();
      },
      referralShares() {
        this.reloadStakes();
      },
      totalsupply() {
        this.reloadStakes();
      },
      totalStakedChanged() {
        this.reloadStakes();
      }
    },
    computed: {
      isMetaMaskConnected() {
        return this.$store.state.web3.connected;
      },
      showIncomeStats() {
        return (this.isMetaMaskConnected && this.stakeAddress === this.$store.state.web3.account) || this.godMode
      },
      showCMIncome() {
        return this.showIncomeStats
      },
      shortenedAccount() {
        let account = this.account;
        return account.slice(0, 6) + "...." + account.slice(-4);
      },
      account() {
        return this.$store.state.web3.account;
      },
      wiseclassesExtended() {
        let extendedWiseClasses = [...this.wiseclasses];
        let position = extendedWiseClasses.findIndex(element => this.wiseclassShares > element.limit);
        if (position < 0) position = extendedWiseClasses.length - 1;
        let me = {
          "name": "ME",
          "limit": this.wiseclassShares,
          "icon": this.wiseclassIcon,
          "color": extendedWiseClasses[position].color
        };
        extendedWiseClasses.splice(position, 0, me);
        // console.log(extendedWiseClasses);
        return extendedWiseClasses;
      },
      currentWisePrice() {
        return this.$store.state.currentETHPrice * this.$store.state.currentUniswapStats.priceETH;
      },
      chartOptionsStakes() {
        var ctx = this;
        return {
          chart: {
            marginRight: 100,
            backgroundColor: null,
            spacingTop: 40,
            type: 'column',
            zoomType: 'x',
            panning: true,
            panKey: 'shift',
            style: {
              fontFamily: "Ubuntu"
            }
          },
          title: {
            text: 'Stakes (WISE and Shares)'
          },
          credits: {
            text: 'wiseinfo.io',
            href: "https://wiseinfo.io",
            style: {
              fontSize: "12px",
              color: "#aaaaaa"
            },
            position: {
              x: -20,
              y: -20
            }
          },
          subtitle: {
            text: 'Click and drag to zoom in. Hold shift to pan.',
            y: -20
          },
          xAxis: [{
            opposite: true,
            type: 'datetime',
            min: Date.UTC(2020, 10, 10, 0),
            // max: new Date(Date.now() + (5555 + 5) * 86400000),
            crosshair: {
              snap: false,
              label: {
                enabled: true,
                backgroundColor: "#666666",
                formatter: function(value) {
                  let string = ((value - Date.UTC(2020, 10, 10, 0)) / 86400000).toFixed(0) + " Days since start<br />";
                  string += ((value - Date.UTC(2020, 10, 10, 0)) / 86400000 - ctx.getCurrentWiseDay()).toFixed(0) + " Days since today<br />";
                  return string
                }
              }
            },
            visible: false,
          }, {
            type: 'datetime',
            linkedTo: 0,
            min: Date.UTC(2020, 10, 10, 0),
            // max: Date.UTC(2035, 11, 31, 0),
            crosshair: {
              snap: false,
              label: {
                enabled: true,
              }
            },
            plotLines: [{
              // value: Date.UTC(2020, 10, 19, 0),
              value: 0,
              color: "#FF0000",
              width: 1,
              label: {
                text: 'Today',
                rotation: 270,
                x: 15,
                y: 90,
                style: {
                  color: "#FF0000",
                }
              }
            }]
            // tickInterval: 24 * 3600 * 1000
          }],
          yAxis: [{
              min: 0.00000001,
              minorTickInterval: 0.1,
              type: 'linear',
              title: {
                text: 'WISE Principle'
              },
            },
            {
              min: 0.00000001,
              minorTickInterval: 0.1,
              type: 'linear',
              opposite: true,
              title: {
                text: 'WISE Shares'
              },
            },
          ],
          plotOptions: {
            series: {
              pointIntervalUnit: 'day'
            },
            column: {
              grouping: false,
              // pointRange: 24 * 3600 * 1000,
              // pointPlacement: 0,
              pointInterval: 24 * 3600 * 1000,
              dataGrouping: {
                enabled: true,
                forced: true,
                groupPixelWidth: 5,
                approximation: 'sum',
                smoothed: true,
                units: [
                  [
                    'day',
                    [1]
                  ],
                  [
                    'week',
                    [1]
                  ],
                  [
                    'month',
                    [1, 3, 6]
                  ],
                  [
                    'year',
                    [1]
                  ]
                ]
              }
            }
          },
          tooltip: {
            shared: true,
            split: false,
            backgroundColor: '#555555',
            borderRadius: 10,
            borderWidth: 1,
            positioner: function(labelWidth, labelHeight, point) {
              let tooltipX = point.plotX;
              let tooltipY = Math.max(point.plotY, 75);
              return {
                x: tooltipX,
                y: tooltipY
              };
            },
          },
          // plotOptions: {
          //   columns: {
          //     stacking: 'normal',
          //     // dataLabels: {
          //     //   enabled: true
          //     // }
          //   }
          // },
          series: [{
              name: 'Active Stakes',
              color: Highcharts.getOptions().colors[2],
              borderColor: Highcharts.getOptions().colors[2],
              tooltip: {
                valueDecimals: 1,
                valueSuffix: " WISE",
              },
              zIndex: 2,
              yAxis: 0,
              data: []
            },
            {
              name: 'Active Shares',
              color: Highcharts.getOptions().colors[3],
              borderColor: Highcharts.getOptions().colors[3],
              tooltip: {
                valueDecimals: 1,
                valueSuffix: " WISE",
              },
              zIndex: 1,
              yAxis: 1,
              visible: false, //default
              data: []
            },
            {
              name: 'Closed Stakes',
              color: "#555555",
              borderColor: "#555555",
              tooltip: {
                valueDecimals: 1,
                valueSuffix: " WISE",
              },
              zIndex: 2,
              yAxis: 0,
              data: []
            },
            {
              name: 'Closed Shares',
              color: "#999999",
              borderColor: "#999999",
              tooltip: {
                valueDecimals: 1,
                valueSuffix: " WISE",
              },
              zIndex: 1,
              yAxis: 1,
              visible: false, //default
              data: []
            }
          ]
        }
      },
      referralLinkStaking() {
        return "https://wisetoken.net/staking/?w=" + config.referralAccount;
      },
      ...mapState({
        metamaskAccountChange: state => state.web3.account,
        metamasknetworkIdChange: state => state.web3.networkId,
        metamaskConnectedChange: state => state.web3.connected,
        referralShares: state => state.referralShares,
        totalsupply: state => state.totalSupply,
        totalStakedChanged: state => state.totalStaked,
      }),
    },
    methods: {
      setMetamaskAccount() {
        this.reloadStakes();
      },
      reloadStakes() {
        if (this.$store.state.web3.connected || this.godMode) {
          if (this.$store.state.web3.connected) {
            this.clearAccount();
            this.stakeAddress = this.$store.state.web3.account;
          }
          this.getStakes();
        }
      },
      updateDirectLink() {
        this.directLink = location.protocol + "//" + location.host + "/account/" + this.stakeAddress;
      },
      scrollMeTo(anchor) {
        VueScrollTo.scrollTo(document.getElementById(anchor));
      },
      getCurrentWiseDay() {
        return this.$store.state.currentWiseDay;
      },

      // resetButtonStates(numberButtons) {
      //   this.buttonStates = [];
      //   for (let i = 0; i < numberButtons; i++) {
      //     this.buttonStates.push(0);
      //   }
      // },
      clearAccount() {
        this.stakeAddress = "";
        this.balance = 0;
        this.balanceUSD = 0;
        this.totalStaked = 0;
        this.totalStakedUSD = 0;
        this.wiseclassShares = 0;
        this.wiseclassName = "";
        this.wiseclassIcon = "";
        this.wiseclassLimit = 0;
        this.wiseclassColor = "rgb(41,171,181)";

        this.existingStakes = [];
        this.checkedStakes = false;
        this.avgLength = 0;
        this.totalShares = 0;
        this.pendingInterest = 0;
        this.pendingInterestUSD = 0;
        this.pendingCMIncome = 0;
        this.totalCMShares = 0;
        this.accountIsCMReferrer = false;
        this.myCMShares = 0;
        this.myCMSharesPercentage = 0;
        this.mySharesPercentage = 0;
        this.numberReferredStakes = 0;
        this.totalReferredUsd = 0;
        this.cmIncomePerDay = 0;
        this.directLink = "";

      },
      // async closeStake(stake) {
      //   //endStake with stakeID
      //   console.log("TODO: endStake with id: " + stake.stakeId);
      //
      //   await this.createContract();
      //
      //   let contractData = this.wiseContract.methods.endStake(stake.stakeId).encodeABI();
      //   const transactionParameters = {
      //     to: this.wiseContract._address, // Required except during contract publications.
      //     from: window.ethereum.selectedAddress, // must match user's active address.
      //     data: contractData, // Optional, but used for defining smart contract creation and interaction.
      //   };
      //
      //   try {
      //     Vue.set(this.buttonStates, stake.index, 1);
      //     const txHash = await window.ethereum.request({
      //       method: 'eth_sendTransaction',
      //       params: [transactionParameters],
      //     });
      //     Vue.set(this.buttonStates, stake.index, 3);
      //     this.getTransactionReceipt(txHash, stake);
      //   } catch (e) {
      //     Vue.set(this.buttonStates, stake.index, 2);
      //   }
      //
      // },
      // async getTransactionReceipt(txHash, stake) {
      //   let receipt = null;
      //   while (receipt === null) {
      //     // we are going to check every second if transation is mined or not, once it is mined we'll leave the loop
      //     receipt = await this.getTransactionReceiptPromise(txHash);
      //     await this.sleep(1000);
      //   }
      //   await Vue.set(this.buttonStates, stake.index, 4);
      //   return receipt;
      // },
      sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      // async getTransactionReceiptPromise(txHash) {
      //   return new Promise(((resolve, reject) => {
      //     this.web3.eth.getTransactionReceipt(txHash, function(err, data) {
      //       if (err !== null) reject(err);
      //       else resolve(data);
      //     });
      //   }));
      // },
      // async createStake(stake) {
      //
      //   await this.createContract();
      //
      //   let stakedAmount = this.web3.utils.toWei(stake.amount.toString(), 'ether');
      //   let lockDays = stake.length;
      //   let referrerAddress = config.referralAccount;
      //
      //   let contractData = this.wiseContract.methods.createStake(stakedAmount, lockDays, referrerAddress).encodeABI();
      //
      //   const transactionParameters = {
      //     // nonce: '0x00', // ignored by MetaMask
      //     // gasPrice: '0x09184e72a000', // customizable by user during MetaMask confirmation.
      //     // gas: '0x2710', // customizable by user during MetaMask confirmation.
      //     to: this.wiseContract._address, // Required except during contract publications.
      //     from: window.ethereum.selectedAddress, // must match user's active address.
      //     // value: '0x00', // Only required to send ether to the recipient from the initiating external account.
      //     data: contractData, // Optional, but used for defining smart contract creation and interaction.
      //     // chainId: 1, // Used to prevent transaction reuse across blockchains. Auto-filled by MetaMask.
      //   };
      //
      //   try {
      //     Vue.set(this.buttonStates, stake.index, 1);
      //     const txHash = await window.ethereum.request({
      //       method: 'eth_sendTransaction',
      //       params: [transactionParameters],
      //     });
      //     Vue.set(this.buttonStates, stake.index, 3);
      //     this.getTransactionReceipt(txHash, stake);
      //     this.checkTransactionStatus();
      //   } catch (e) {
      //     Vue.set(this.buttonStates, stake.index, 2);
      //     this.checkTransactionStatus();
      //   }
      //
      // },
      getClassShares(stakes, liquid) {
        let amountPower = 1.1;
        let lengthFactor = 10;
        let liquidPower = 1.1;
        let passedDaysFactor = 0.25;
        let openDaysFactor = 0.75;
        let totalFactor = 0.01;

        let currentWiseDay = this.$store.state.currentWiseDay;
        let classshares = stakes.reduce((sum, stake) => {
          let stakeAmount = parseInt((stake.stakedAmount) / 10 ** 18);
          let openDays = parseInt(stake.finalDay) - currentWiseDay;
          let passedDays = currentWiseDay - parseInt(stake.startDay);
          if (openDays < 0) {
            openDays = 0;
            passedDays = parseInt(stake.lockDays);
          }
          let stakeAmountWCP = (stakeAmount ** amountPower);
          let lengthWCP = 1 + lengthFactor * (openDaysFactor * openDays + passedDaysFactor * passedDays) / 365;
          let stakeWCP = stakeAmountWCP * lengthWCP;
          return sum + stakeWCP;
        }, 0);
        let liquidWCP = liquid ** liquidPower;
        classshares += liquidWCP;
        classshares *= totalFactor;
        return classshares;
      },
      // getClassShares_old2(stakes, liquid) {
      //   let amountPower = 1.1;
      //   let lengthPower = 1.3;
      //   let liquidPower = 2 / 3;
      //   // let timeFactor = 15; // 15 liquid wise is equal to 1 wise staked for 1 year
      //   let passedDaysFactor = 0.5;
      //   let lengthWeight = 1 / 200;
      //   let currentWiseDay = this.$store.state.currentWiseDay;
      //   let classshares = stakes.reduce((sum, stake) => {
      //     let stakeAmount = parseInt((stake.stakedAmount) / 10 ** 18);
      //     // let stakeLength = parseInt(stake.lockDays);
      //     let openDays = parseInt(stake.finalDay) - currentWiseDay;
      //     let passedDays = currentWiseDay - parseInt(stake.startDay);
      //     if(openDays < 0) {
      //       openDays = 0;
      //       passedDays = parseInt(stake.lockDays);
      //     }
      //
      //     // let WCP = (stakeAmount ** amountWeight) * timeWeight * stakeLength;
      //     // 10000^(2/3)*0.0167*(300 + 65*0.5)
      //     let WCP = ((stakeAmount/100) ** amountPower) * lengthWeight * (openDays + passedDays * passedDaysFactor) ** lengthPower;
      //     return sum + WCP;
      //   }, 0);
      //   //1000^(2/3)
      //   classshares += liquid ** liquidPower;
      //   console.log(`getClassShares_old2 classshares: ${classshares}`);
      //   return classshares;
      // },
      // getClassShares_old(stakes, liquid) {
      //   let amountWeight = 2 / 3;
      //   let timeFactor = 15; // 15 liquid wise is equal to 1 wise staked for 1 year
      //   let passedDaysFactor = 0.5;
      //   let timeWeight = (timeFactor ** amountWeight) / 365;
      //   let currentWiseDay = this.$store.state.currentWiseDay;
      //   let classshares = stakes.reduce((sum, stake) => {
      //     let stakeAmount = parseInt((stake.stakedAmount) / 10 ** 18);
      //     // let stakeLength = parseInt(stake.lockDays);
      //     let openDays = parseInt(stake.finalDay) - currentWiseDay;
      //     let passedDays = currentWiseDay - parseInt(stake.startDay);
      //     if(openDays < 0) {
      //       openDays = 0;
      //       passedDays = parseInt(stake.lockDays);
      //     }
      //
      //     // let WCP = (stakeAmount ** amountWeight) * timeWeight * stakeLength;
      //     // 10000^(2/3)*0.0167*(300 + 65*0.5)
      //     let WCP = (stakeAmount ** amountWeight) * timeWeight * (openDays + passedDays * passedDaysFactor);
      //     return sum + WCP;
      //   }, 0);
      //   //1000^(2/3)
      //   classshares += liquid ** amountWeight;
      //   console.log(`getClassShares_old classshares: ${classshares}`);
      //   return classshares;
      // },
      getWiseClass(classshares) {
        let wiseclasses = config.wiseclasses;
        let wiseclass = {};
        for (let index = wiseclasses.length - 1; index >= 0; index--) {
          let testclass = wiseclasses[index];
          if (classshares >= testclass.limit) {
            wiseclass = testclass;
          } else {
            break;
          }
        }
        return wiseclass;
      },
      getWeightedAverageLength(stakes) {
        if (stakes.length === 0) return 0;
        let sumSizesLength = stakes.reduce((a, b) => a + (parseInt(b.stakedAmount) * parseInt(b.lockDays)), 0);
        let numberElements = stakes.length;
        let avgsumSizesLength = sumSizesLength / numberElements;
        let avgSize = this.getAverageStakeSize(stakes);
        return avgsumSizesLength / avgSize;
      },
      getAverageStakeSize(stakes) {
        let sumSizes = stakes.reduce((a, b) => a + parseInt(b.stakedAmount), 0);
        let numberElements = stakes.length;
        return sumSizes / numberElements;
      },
      processStakes(stakes) {
        let processedStakes = [];
        processedStakes = stakes.map(stake => {
          let daysPassed = this.$store.state.currentWiseDay - parseInt(stake.startDay);
          let daysOpen = parseInt(stake.lockDays) + parseInt(stake.startDay) - this.$store.state.currentWiseDay;
          if (this.$store.state.currentWiseDay > stake.endDay) {
            daysPassed = parseInt(stake.lockDays);
            daysOpen = 0;
          }
          let rewardPerDay = parseInt(stake.rewardAmount) / daysPassed;
          return {
            ...stake,
            'daysPassed': daysPassed,
            'daysOpen': daysOpen,
            'rewardPerDay': rewardPerDay
          };
        });
        return processedStakes;
      },
      getWiseClassAttributes(stakes) {
        this.wiseclassShares = this.getClassShares(stakes, this.balance);
        let wiseClass = this.getWiseClass(this.wiseclassShares);
        this.wiseclassName = wiseClass.name;
        this.wiseclassIcon = wiseClass.icon;
        this.wiseclassLimit = wiseClass.limit;
        this.wiseclassColor = wiseClass.color;
      },
      getInterestIncomeAttributes(stakes) {
        this.totalRewardsPerDay = stakes.reduce((total, stake) => total += stake.rewardPerDay, 0) / 10 ** 18;
        this.totalAPY = this.totalRewardsPerDay / this.totalStaked * 365 * 100;
        this.pendingInterest = stakes.reduce((total, stake) => total += parseFloat(stake.rewardAmount), 0) / 10 ** 18;
        this.pendingInterestUSD = this.pendingInterest * this.currentWisePrice;
      },
      getBalanceAttributes(stakes) {
        // this.balance = await getBalance(this.stakeAddress);
        // this.balanceUSD = this.balance * this.currentWisePrice;
        getBalance(this.stakeAddress)
          .then(result => {
            this.balance = result;
            this.balanceUSD = this.balance * this.currentWisePrice;
          })
        this.totalStaked = stakes.filter(stake => stake.isActive).reduce((total, stake) => total += parseFloat(stake.stakedAmount), 0) / 10 ** 18;
        this.totalStakedUSD = this.totalStaked * this.currentWisePrice;
      },

      async getNumberOfReferredStakes() {
        let numberReferredStakes = await this.wiseContract.methods.referralCount(this.stakeAddress).call();
        return numberReferredStakes;
      },

      async getReferralIds(numberOfReferredStakes) {
        let idsOfReferredStakes = await this.wiseContract.methods.referralsPagination(this.stakeAddress, 0, numberOfReferredStakes).call();
        return idsOfReferredStakes
      },

      async getAllReferredStakes(referralIds) {
        let referredStakesMap = new Map();
        let promises = [];
        try {
          for (const referralId of referralIds) {
            promises.push(this.wiseContract.methods.checkReferralsByID(this.stakeAddress, referralId).call({}, function(err, stake) {
              if (!err) {
                referredStakesMap.set(referralId, stake);
              }
            }));
          }
          await Promise.all(promises);
        } catch (ex) {
          console.log(ex.message)
        }
        return referredStakesMap;
      },

      receivedAllNeededDataForCMAttributes() {
        return (
          this.$store.state.referralShares > 0 &&
          this.$store.state.totalSupply > 0 &&
          this.$store.state.totalStaked > 0
        );
      },

      async getCMIncomeAttributes() {
        if (!this.receivedAllNeededDataForCMAttributes()) {
          return;
        }
        await this.createContract();
        let myCMShares = 0;
        let totalCMInterest = 0;
        this.numberReferredStakes = await this.getNumberOfReferredStakes();
        let referralIds = await this.getReferralIds(this.numberReferredStakes);
        // console.log(referralIds);
        let referredStakesMap = await this.getAllReferredStakes(referralIds);
        // let referredStakesMap = await this.getAllReferredStakes(referralIds.slice(0, 3));

        referredStakesMap.forEach(stake => {
          myCMShares += parseInt(stake.referrerShares);
          totalCMInterest += parseInt(stake.referralInterest);
        })
        myCMShares /= 10 ** 18;
        totalCMInterest /= 10 ** 18;

        let percentageCmShares = myCMShares / this.$store.state.referralShares;
        // console.log(`this.$store.state.referralShares: ${this.$store.state.referralShares}`)
        // console.log(`percentageCmShares: ${percentageCmShares}`)

        let totalMinted = this.$store.state.totalSupply + this.$store.state.totalStaked;
        let yearlyReferrerInflation = 0.01 * totalMinted;
        // console.log(`totalMinted: ${totalMinted}`)
        let myYearlyReferrerWise = percentageCmShares * yearlyReferrerInflation;
        // console.log(`myYearlyReferrerWise: ${myYearlyReferrerWise}`)

        this.myCMShares = myCMShares;
        this.myCMSharesPercentage = percentageCmShares;
        this.pendingCMIncome = totalCMInterest;
        this.cmIncomePerDay = myYearlyReferrerWise / 365;
        this.cmIncomeLoading = false;
        // this.showCMIncome = true;
      },
      async isCMReferrer() {
        await this.createContract();
        let cm = await this.wiseContract.methods.criticalMass(this.stakeAddress).call();
        let accountIsCMReferrer = (parseInt(cm['activationDay']) > 0);
        this.accountIsCMReferrer = accountIsCMReferrer;
        if (accountIsCMReferrer && this.wiseclassLimit == 0) {
          this.wiseclassIcon = "🔱";
          this.wiseclassName = "CM Referrer"
        }
        this.totalReferredUsd = parseInt(cm['totalAmount']) / 10 ** 18;
        return accountIsCMReferrer;
      },
      async getStakes() {
        let validAccount = await isValidAccount(this.stakeAddress);
        if (!validAccount) {
          this.existingStakes = [];
          this.checkedStakes = false;
        } else {
          this.graphLoading = true;
          this.checkedStakes = false;
          this.updateDirectLink();
          let stakes = null;
          let processedStakes = [];
          try {
            stakes = await getStakes(this.stakeAddress);
            processedStakes = this.processStakes(stakes);

            this.avgLength = this.getWeightedAverageLength(processedStakes);
            this.totalShares = processedStakes.filter(stake => stake.isActive).reduce((total, stake) => total += parseFloat(stake.stakesShares), 0) / 10 ** 18;

            this.mySharesPercentage = this.totalShares / this.$store.state.totalShares;

            this.checkedStakes = true;
            this.getBalanceAttributes(processedStakes);
            this.getInterestIncomeAttributes(processedStakes);
            this.getWiseClassAttributes(processedStakes);

            // this.graphLoading = false;

            if (this.showIncomeStats) {
              let isAccountCMReferrer = await this.isCMReferrer();
              if (isAccountCMReferrer) {
                this.cmIncomeLoading = true;
                // this.showCMIncome = true;
                this.getCMIncomeAttributes();
                // this.cmIncomeLoading = false;
              }
            }
          } catch (exp) {
            console.log(exp.message);
          }
          if (processedStakes === null) {
            this.existingStakes = [];
            this.graphLoading = false;
          } else {
            processedStakes = processedStakes.map((stake, index) => {
              return {
                ...stake,
                index: index
              }; //equivalent to list[index]
            });
            // this.resetButtonStates(processedStakes.length);
            this.existingStakes = processedStakes;
          }
        }
        this.existingStakes.sort((a, b) => parseInt(a.finalDay) > parseInt(b.finalDay) ? 1 : -1);
        this.generateGraphData();

        this.graphLoading = false;
      },
      generateGraphData() {
        // this.graphLoading = true;
        this.showGraph = false;
        let startDate = new Date(Date.UTC(2020, 10, 10)).getTime();
        let millisecondsPerDay = 86400000;
        let wiseStakesActive = [];
        let wiseSharesActive = [];
        let wiseStakesClosed = [];
        let wiseSharesClosed = [];

        wiseStakesActive = this.existingStakes.filter(stake => stake.isActive).map(stake => {
          let amountWise = stake.stakedAmount / 10 ** 18;
          let endDate = startDate + stake.finalDay * millisecondsPerDay;
          return [endDate, amountWise];
        });
        wiseSharesActive = this.existingStakes.filter(stake => stake.isActive).map(stake => {
          let amountWise = stake.stakesShares / 10 ** 18;
          let endDate = startDate + stake.finalDay * millisecondsPerDay;
          return [endDate, amountWise];
        });

        wiseStakesClosed = this.existingStakes.filter(stake => !stake.isActive).map(stake => {
          let amountWise = stake.stakedAmount / 10 ** 18;
          let endDate = startDate + stake.finalDay * millisecondsPerDay;
          return [endDate, amountWise];
        });
        wiseSharesClosed = this.existingStakes.filter(stake => !stake.isActive).map(stake => {
          let amountWise = stake.stakesShares / 10 ** 18;
          let endDate = startDate + stake.finalDay * millisecondsPerDay;
          return [endDate, amountWise];
        });

        // for (let stake of this.existingStakes) {
        //   let amountWise = stake.stakedAmount / 10 ** 18;
        //   let endDate = startDate + stake.finalDay * millisecondsPerDay;
        //   wiseStakesActive.push([endDate, amountWise]);
        // }

        wiseStakesActive.sort((a, b) => a[0] > b[0] ? 1 : -1);
        wiseSharesActive.sort((a, b) => a[0] > b[0] ? 1 : -1);
        wiseStakesClosed.sort((a, b) => a[0] > b[0] ? 1 : -1);
        wiseSharesClosed.sort((a, b) => a[0] > b[0] ? 1 : -1);

        this.chartOptionsStakes.series[0].data = wiseStakesActive;
        this.chartOptionsStakes.series[1].data = wiseSharesActive;
        this.chartOptionsStakes.series[2].data = wiseStakesClosed;
        this.chartOptionsStakes.series[3].data = wiseSharesClosed;

        let currentWiseDay = this.$store.state.currentWiseDay;

        this.chartOptionsStakes.xAxis[1].plotLines[0].value = startDate + currentWiseDay * millisecondsPerDay;
        this.chartOptionsStakes.xAxis[1].plotLines[0].label.text = "Today (Day " + currentWiseDay + ")";

        // this.setAxisLogScale(true);
        this.showGraph = true;
        // this.graphLoading = false;

      },
      setAxisLogScale(log) {
        if (log) {
          this.chartOptionsStakes.yAxis[0].type = 'logarithmic';
          this.chartOptionsStakes.yAxis[1].type = 'logarithmic';
        } else {
          this.chartOptionsStakes.yAxis[0].type = 'linear';
          this.chartOptionsStakes.yAxis[1].type = 'linear';
        }
      },
      // async createContract() {
      //   if (this.wiseContract === null) {
      //     this.wiseContract = await getInfuraWiseContract();
      //     this.web3 = await getInfuraWeb3();
      //   }
      // },
      async createContract() {
        let {
          getWiseContract,
          getWeb3
        } = process.env.VUE_APP_ENVIRONMENT === "development" ?
          // let {
          //   getInfuraWiseContract,
          //   getInfuraWeb3
          // } = process.env.VUE_APP_ENVIRONMENT === "development" ?
          await import('../utils/contract_testnet_staking') :
          await import('../utils/contract_mainnet_staking')
        if (this.wiseContract === null) {
          // this.wiseContract = await getInfuraWiseContract();
          this.wiseContract = await getWiseContract();
        }
        if (this.web3 === null) {
          // this.web3 = await getInfuraWeb3();
          this.web3 = await getWeb3();
        }
      },
      connectMetamask() {
        console.log("connecting metamask");
        connectWeb3();
      },
      captureReferralLink(category, url) {
        this.$ga.event(category, 'click', url, 1234);
      }
    }
  }
</script>

<style lang="css" scoped>

.v-data-table table tr td,
.v-data-table table tr th {
   font-size: 10px !important;
   padding: 0px 10px !important;
}
a.helplink {
  color: #aaaaaa;
}

.shadow {
  text-shadow: 5px 2px 5px #555555;
}
.shadowsmall {
  text-shadow: 2px 1px 3px #555555;
}
.v-application .body-1 {
    line-height: 1.0rem;
}
.tealtext {
  color: #29ABB5
}
</style>
